import React, { ChangeEvent } from 'react'
import { useGMapInput } from './hooks/useGMapInput'
import classes from './GMapInput.module.sass'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'
import { AddressInterface, CityInterface } from '../../types/interfaces'

export type GMapInputProps<T> = {
  fieldName: 'city' | 'address'
  setData: (inputData: T) => void
  data: T
  placeHolder: string
  required?: boolean
}

export const GMapInput = <T extends { city: CityInterface; address: AddressInterface }>({
  fieldName,
  setData,
  data,
  placeHolder,
  required,
}: GMapInputProps<T>) => {
  const { dataReset } = useGMapInput(fieldName, setData, data)

  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={classes.container}>
      <input
        className={darkTheme ? classes.InputDark : classes.Input}
        style={{ borderLeft: required && !data[fieldName].latitude ? 'solid 1px red' : '' }}
        id={`${fieldName}`}
        name={fieldName}
        defaultValue={data[fieldName].value}
        placeholder={placeHolder}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          dataReset(e)
        }}
        onBlur={() => {
          let tempData = { ...data }
          tempData[fieldName].isDirty = true
          setData(tempData)
        }}
      />
      <div className={classes.validationErrorField}>
        {!data[fieldName].latitude && data[fieldName].isDirty
          ? `Выберите ${fieldName === 'address' ? 'адрес' : 'город'} из списка`
          : ''}
      </div>
    </div>
  )
}
